// extracted by mini-css-extract-plugin
export default {"favouriteSelectionsList":"FavouritesList_favouriteSelectionsList__YQ1Zc"};